
export enum RemitRecordAction {
  REMIT_DETAILS = "REMIT_DETAILS"
}

export const ITEM_MENU_DEFAULT_STATE = {
  visible: false,
  id: "",
};

export const DEFAULT_DRAWER_STATE = {
  visible: false,
  remitRecord: {} as any
};
